import { useState, useEffect } from 'react'
import {useFileView} from '../../providers/FileViewProvider';
import Select from 'react-select';

export type TOption = {
  value: string;
  label: string;
}

export const Project = (props: {options : TOption[]}) => {
  const defaultOptions = props.options;
  const fileView = useFileView();
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [options, setOptions] = useState<TOption[]>();
  const [project, setProject] = useState("");

  // const handleChange = ( e :React.ChangeEvent<HTMLInputElement>) => {
  //   fileView.setSearchProject(e.target.value);
  // };
  useEffect(() => {
    // リストを作成
    let newOptions :TOption[] = [];
    newOptions.push({ label: "", value: "" });  // index:0は入力用
    defaultOptions.forEach((value, index) => {
      if (value.value === fileView.getSearchProject()) {
        setSelectedIndex(index+1);
      }
      newOptions.push(value);
    });
    setOptions(newOptions);
    // eslint-disable-next-line
  }, [defaultOptions]);

  const customStyles = {
    menu: (provided:any, state:any) => ({
      ...provided,
      width: "250px",
      color: state.selectProps.menuColor,
      padding: 0,
    }),
    control: (provided:any, state:any) => ({
      ...provided,
      width: "250px",
      color: state.selectProps.menuColor,
      padding: 0,
    }),
    dropdownIndicator: (provided:any, state:any) => ({
      ...provided,
      color: state.selectProps.menuColor,
      padding: 0,
    }),
    singleValue: (provided:any, state:any) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    }
  };

  const handleChange = (project: string) => {
    setProject(project);
    fileView.setSearchProject(project);
    let newOptions: TOption[] = [...options!];
    newOptions[0] = { label: "", value: "" };
    setOptions(newOptions);

    if (project === "") {
      setSelectedIndex(-1);
    } else {
      newOptions!.forEach((value, index) => {
        if (project === value.value) {
          setSelectedIndex(index);
        }
      });
    }
  };

  const handleInput = (project: string) => {
    if (project !== "") {
      fileView.setSearchProject(project);
      setProject(project);
    }
  };

  return (
    <div className="inline-block ml-4 mt-2">
      <label htmlFor="email" className="block text-sm font-medium text-gray-600">
        案件
      </label>
      <div className="mt-1">
        {options && <Select
          onBlur={(e) => {
            let newOptions: TOption[] = [...options!];
            newOptions[0] = { label: project, value: project };
            setOptions(newOptions);
            setSelectedIndex(project === "" ? -1 : 0);
          }}
          className="text-gray-600 text-xs inline-block mr-2"
          styles={customStyles}
          options={options}
          value={options[selectedIndex!]}
          placeholder="指定なし"
          isClearable={true}
          noOptionsMessage={({ inputValue }) => !inputValue ? "" : "入力に一致する候補はありません"}
          onChange={(e) => {
            handleChange(e?.value || "");
          }}
          onInputChange={(e) => {
            handleInput(e || "");
          }}
        />
        }

      </div>
    </div>
  )
}

export default Project;
